import React from 'react';

type Props = {
  playId: string;
};

const OfferReports: React.FC<Props> = ({ playId }) => {
  return (
    <div>Unified Play Offer Reporting Dashboard for Play ID: {playId}</div>
  );
};

export default OfferReports;
